import React, { useEffect, useState } from 'react';
import { Button } from 'antd';
import { FormattedMessage } from 'react-intl';
import ReactGA from 'react-ga4';
import configuration from '../../configs/Configuration';
import styles from './CookieConsentBanner.module.scss';

const CONSENT_KEY = 'cookie_consent';

const initGA = () => {
    if (configuration.gaTrackingId) {
        ReactGA.initialize(configuration.gaTrackingId);
    }
};

const CookieConsentBanner: React.FC = () => {
    const [visible, setVisible] = useState<boolean>(false);

    useEffect(() => {
        const consent = localStorage.getItem(CONSENT_KEY);
        if (consent === 'accepted') {
            initGA();
        } else if (consent !== 'rejected') {
            setVisible(true);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem(CONSENT_KEY, 'accepted');
        initGA();
        setVisible(false);
    };

    const handleReject = () => {
        localStorage.setItem(CONSENT_KEY, 'rejected');
        setVisible(false);
    };

    if (visible) {
        return (
            <div className={styles.banner}>
                <p className={styles.message}>
                    <FormattedMessage id="cookie.consent.message" />{' '}
                    <a href="/privacy-policy">
                        <FormattedMessage id="cookie.consent.moreInfo" />
                    </a>
                </p>
                <div className={styles.actions}>
                    <Button ghost onClick={handleReject}>
                        <FormattedMessage id="cookie.consent.reject" />
                    </Button>
                    <Button type="primary" onClick={handleAccept}>
                        <FormattedMessage id="cookie.consent.accept" />
                    </Button>
                </div>
            </div>
        );
    } else {
        return null;
    }
};

export default CookieConsentBanner;
